export const CHAT_POLL_INTERVAL_MS = 15_000;
export const CHAT_REALTIME_POLL_INTERVAL_MS = 60_000;
export const CHAT_INBOX_CONNECTION_EVENT = "vg:chat-inbox-connection";
